/*
 * @Description:  * @Date: 2025-09-01 10:22:20
 * @LastEditTime: 2026-10-27 16:10:01
 * @FilePath: \hui_ai_ui\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
// ▼▼▼ 1. 导入您真正的API方法 ▼▼▼
// 假设您的 getUserId 方法在 'api/auth.js' 文件中
import { getUserId,getLoginInfo,getPCuserInfo,getUserToken,saveToken } from '../api/ai/training'
import { isDesktop } from '../config'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    userId: null,         // 这里将存放【真实】的userId
    userName: null,       // 存储用户名
    longUserId: null,     // 存储长用户ID
    isInitializing: true,
    initError: null,
    loginInfo: null,      // 存储从URL获取的loginInfo参数
    isSidebarVisible: true, // 侧边栏是否可见
    showLoginDialog: false, // 是否显示登录对话框(Tauri)
    showLoginWebDialog: false, // 是否显示登录对话框(Web)
    showResetPasswordDialog: false, // 是否显示重置密码对话框
    // 全局确认弹窗
    showGlobalConfirm: false,
    globalConfirmTitle: '',
    globalConfirmMessage: '',
    globalConfirmCallback: null,
    // WebSocket TTS 连接状态
    wsTtsConnected: false,
    wsTtsUserId: null,
    // 聊天会话列表（全局缓存）
    chatSessions: [],
  },
  getters: {
    userId: state => state.userId,
    userName: state => state.userName,
    longUserId: state => state.longUserId,
    isInitializing: state => state.isInitializing,
    initError: state => state.initError,
    getLoginInfo: state => state.loginInfo,
    isSidebarVisible: state => state.isSidebarVisible,
    isSidebarHidden: state => !state.isSidebarVisible,
    showLoginDialog: state => state.showLoginDialog,
    showLoginWebDialog: state => state.showLoginWebDialog,
    showResetPasswordDialog: state => state.showResetPasswordDialog,
    // 全局确认弹窗
    showGlobalConfirm: state => state.showGlobalConfirm,
    globalConfirmTitle: state => state.globalConfirmTitle,
    globalConfirmMessage: state => state.globalConfirmMessage,
    globalConfirmCallback: state => state.globalConfirmCallback,
    // WebSocket TTS 连接状态
    wsTtsConnected: state => state.wsTtsConnected,
    wsTtsUserId: state => state.wsTtsUserId,
    // 聊天会话列表
    chatSessions: state => state.chatSessions,
  },
  mutations: {
    SET_USER_ID(state, id) {
      state.userId = id;
      // 用户ID设置成功 身份校验通过 状态初始化
      state.initError = null;
      state.isInitializing = false;
    },
    SET_USER_NAME(state, name) {
      state.userName = name
    },
    SET_LONG_USER_ID(state, id) {
      state.longUserId = id
    },
    SET_INITIALIZING(state, status) {
      state.isInitializing = status
    },
    SET_INIT_ERROR(state, error) {
      state.initError = error
    },
    SET_LOGIN_INFO(state, loginInfo) {
      state.loginInfo = loginInfo
    },
    SET_SIDEBAR_VISIBLE(state, visible) {
      state.isSidebarVisible = visible
    },
    TOGGLE_SIDEBAR(state) {
      state.isSidebarVisible = !state.isSidebarVisible
    },
    SET_SHOW_LOGIN_DIALOG(state, show) {
      state.showLoginDialog = show
    },
    SET_SHOW_LOGIN_WEB_DIALOG(state, show) {
      state.showLoginWebDialog = show
    },
    SET_SHOW_RESET_PASSWORD_DIALOG(state, show) {
      state.showResetPasswordDialog = show
    },
    // 全局确认弹窗
    SHOW_GLOBAL_CONFIRM(state, { title, message, callback }) {
      state.showGlobalConfirm = true
      state.globalConfirmTitle = title
      state.globalConfirmMessage = message
      state.globalConfirmCallback = callback
    },
    HIDE_GLOBAL_CONFIRM(state) {
      state.showGlobalConfirm = false
      state.globalConfirmCallback = null
    },
    SET_WS_TTS_CONNECTED(state, { connected, userId }) {
      state.wsTtsConnected = connected
      state.wsTtsUserId = userId
    },
    SET_CHAT_SESSIONS(state, sessions) {
      state.chatSessions = sessions
    },
    ADD_CHAT_SESSIONS(state, sessions) {
      state.chatSessions = [...state.chatSessions, ...sessions]
    },
    UPDATE_CHAT_SESSION_TITLE(state, { sessionId, title }) {
      const session = state.chatSessions.find(s => s.id === sessionId);
      if (session) {
        session.title = title;
      }
    }
  },
  actions: {
    // ▼▼▼ 2. 这是我们改造后的核心 action ▼▼▼
    async initializeUser({ commit, state }) {
      commit('SET_INITIALIZING', true);
      commit('SET_INIT_ERROR', null);
      try {
        // 从 localStorage 回灌认证凭据到 sessionStorage（持久化登录）
        try {
          const lsUserId = localStorage.getItem('userId'); // 本地缓存
          if (!sessionStorage.getItem('userId') && lsUserId) { // 新窗口没session 从本地
            sessionStorage.setItem('userId', lsUserId);
            const lsPctoken = localStorage.getItem('pctoken');
            const lsLoginInfo = localStorage.getItem('loginInfoFromUrl');
            const lsFromOA = localStorage.getItem('fromOA');
            if (lsPctoken) sessionStorage.setItem('pctoken', lsPctoken);
            if (lsLoginInfo) sessionStorage.setItem('loginInfoFromUrl', lsLoginInfo);
            if (lsFromOA) sessionStorage.setItem('fromOA', lsFromOA);
          }
        } catch (e) { /* 忽略 localStorage 异常（隐私模式等） */ }

        // 解析URL参数，处理hash模式下的参数
        let urlParams = new URLSearchParams(window.location.search);
        let hashParams = new URLSearchParams();
        
        // 检查hash部分是否有参数
        if (window.location.hash.includes('?')) {
          const hash = window.location.hash.split('?')[1];
          hashParams = new URLSearchParams(hash);
        }
        // 优先使用hash中的参数
        const tempIdFromUrl = hashParams.get('userId') || urlParams.get('userId');
        // 从URL获取loginInfo参数（token不再通过URL传递）
        let loginInfoFromUrl = hashParams.get('loginInfo') || urlParams.get('loginInfo');

        // 快照：URL 只有 userId、没有 loginInfo → 需要与本地缓存比对用户身份
        const urlHasOnlyUserId = !!(tempIdFromUrl && !loginInfoFromUrl);

        // 标记是否从URL中获取到了登录信息
        let hasUrlLoginInfo = false;
        
        // 优先处理URL中的登录信息
        if (loginInfoFromUrl) {
          sessionStorage.setItem('loginInfoFromUrl', loginInfoFromUrl);
          sessionStorage.setItem('fromOA', 'true');
          try { localStorage.setItem('loginInfoFromUrl', loginInfoFromUrl); localStorage.setItem('fromOA', 'true'); } catch (e) {}
          // sessionStorage.setItem('userType', '200'); //oa model展示
          // 清除可能存在的token信息，避免两种登录方式并存
          sessionStorage.removeItem('pctoken');
          try { localStorage.removeItem('pctoken'); } catch (e) {}
          hasUrlLoginInfo = true;
        }
        
        // URL 里没有 loginInfo → 从 sessionStorage 恢复登录状态
        let token = null; // 本地缓存的 pctoken（PC 端凭据）
        if (!hasUrlLoginInfo) {
          loginInfoFromUrl = sessionStorage.getItem('loginInfoFromUrl');
          token = sessionStorage.getItem('pctoken');
          
          // 根据从sessionStorage获取的信息设置fromOA状态
          if (loginInfoFromUrl) {
            sessionStorage.setItem('fromOA', 'true');
            try { localStorage.setItem('fromOA', 'true'); } catch (e) {}
            // sessionStorage.setItem('userType', '200');
          } else if (token) {
            sessionStorage.setItem('fromOA', 'false');
            try { localStorage.setItem('fromOA', 'false'); } catch (e) {}
          }
        }
        if (urlHasOnlyUserId) {
          const urlLongIdNum = parseInt(tempIdFromUrl, 10);

          // ---- 第一优先级：sessionStorage（当前标签页会话）----
          let cachedUserData = null;
          try {
            const ssUserIdPayload = sessionStorage.getItem('userId');
            if (ssUserIdPayload) {
              cachedUserData = JSON.parse(ssUserIdPayload);
            }
          } catch (e) { /* 忽略解析异常 */ }

          // sessionStorage 里没有 → 退到 localStorage（跨标签/会话兜底）
          if (!cachedUserData) {
            try {
              const lsUserIdPayload = localStorage.getItem('userId');
              if (lsUserIdPayload) {
                cachedUserData = JSON.parse(lsUserIdPayload);
              }
            } catch (e) { /* 忽略隐私模式或解析异常 */ }
          }

          const cachedLongId = cachedUserData?.longId || null;

          if (cachedLongId) {
            if (cachedLongId !== urlLongIdNum) {
              // URL 里的长 userId 与本地缓存不属于同一用户 → 清空所有凭据，强制重新登录
              console.warn(`URL userId=${tempIdFromUrl} 与本地缓存 longId=${cachedLongId} 不一致，清除凭据重新登录`);
              sessionStorage.removeItem('userId');
              sessionStorage.removeItem('pctoken');
              sessionStorage.removeItem('loginInfoFromUrl');
              sessionStorage.removeItem('fromOA');
              try {
                localStorage.removeItem('userId');
                localStorage.removeItem('pctoken');
                localStorage.removeItem('loginInfoFromUrl');
                localStorage.removeItem('fromOA');
                localStorage.removeItem('_authCachedAt');
              } catch (e) {}
              return;
            } else {
              // cachedLongId === urlLongIdNum → 同一用户，恢复 state 跳过后续 API
              // 凭据校验：pctoken（PC 登录）或 loginInfoFromUrl（OA 登录）至少有一个
              // 优先从 sessionStorage 取凭据，没有再从 localStorage 取
              let lsPctoken = sessionStorage.getItem('pctoken');
              let lsLoginInfo = sessionStorage.getItem('loginInfoFromUrl');
              let fromOA = sessionStorage.getItem('fromOA');
              if (!lsPctoken) { try { lsPctoken = localStorage.getItem('pctoken'); } catch (e) {} }
              if (!lsLoginInfo) { try { lsLoginInfo = localStorage.getItem('loginInfoFromUrl'); } catch (e) {} }
              if (!fromOA) { try { fromOA = localStorage.getItem('fromOA'); } catch (e) {} }

              if (cachedUserData.id && (lsPctoken || lsLoginInfo)) {
                commit('SET_USER_ID', cachedUserData.id);
                if (cachedUserData.userName) commit('SET_USER_NAME', cachedUserData.userName);
                if (cachedUserData.longId) commit('SET_LONG_USER_ID', cachedUserData.longId);
                // 同步到 sessionStorage，保证其他模块从 sessionStorage 读取也能拿到
                const userIdPayload = JSON.stringify(cachedUserData);
                sessionStorage.setItem('userId', userIdPayload);
                if (lsPctoken) sessionStorage.setItem('pctoken', lsPctoken);
                if (lsLoginInfo) sessionStorage.setItem('loginInfoFromUrl', lsLoginInfo);
                if (fromOA) sessionStorage.setItem('fromOA', fromOA);
                // 同时写入 localStorage 保持持久化（已有的会被覆盖，无副作用）
                try {
                  localStorage.setItem('userId', userIdPayload);
                  if (lsPctoken) localStorage.setItem('pctoken', lsPctoken);
                  if (lsLoginInfo) localStorage.setItem('loginInfoFromUrl', lsLoginInfo);
                  if (fromOA) localStorage.setItem('fromOA', fromOA);
                } catch (e) {}
                // console.log('URL userId 与本地缓存一致，直接恢复用户，跳过后续 API 调用');
                return;
              }
            }
          }
          // cachedLongId 为空 → sessionStorage 和 localStorage 都没有缓存，继续走后续流程
        }

        if (!tempIdFromUrl && !loginInfoFromUrl && !token) { //没userId,oa-loginInfo,pc-token 从缓存拿 userId
          // 1. 首先尝试从 sessionStorage 获取 userId
          const storedUserId = sessionStorage.getItem('userId');
          // 同时检查 sessionStorage 中是否有有效的 token 或 OA 登录信息
          const storedPctoken = sessionStorage.getItem('pctoken');
          const storedLoginInfo = sessionStorage.getItem('loginInfoFromUrl');
          if (storedUserId && (storedPctoken || storedLoginInfo)) {
            // 只有 userId 且同时存在 pctoken 或 loginInfoFromUrl 缓存才允许恢复
            try {
              const userData = JSON.parse(storedUserId);
              if (userData.id) {
                commit('SET_USER_ID', userData.id);
                // 如果 sessionStorage 中包含用户名，也设置到 state 中
                if (userData.userName) {
                  commit('SET_USER_NAME', userData.userName);
                }
                // 从userId缓存中获取longId
                if (userData.longId) {
                  commit('SET_LONG_USER_ID', userData.longId);
                }
                return; // 成功从 sessionStorage 获取，直接返回
              }
            } catch (e) {
              console.warn('解析 sessionStorage userId失败，将重新获取:', e);
            }
          } else {
            // 只有 userId 没有 token，或完全没有缓存 → 视为未登录，清除残留缓存后让 finally 块触发登录页面
            console.log('缓存中 userId 存在但缺少 token，清除残留缓存');
            sessionStorage.removeItem('userId');
            try { localStorage.removeItem('userId'); localStorage.removeItem('_authCachedAt'); } catch (e) {}
          }
        }

        // 辅助函数：处理用户ID验证和存储，把长 userId 转换为短 userId
        const processUserId = async (tempId,userName = '') => {
          const response = await getUserId(tempId);
          const realUserId = response.data;
          if (realUserId) {
            // 统一转 int，避免接口返回 string 导致后续类型比较出问题
            const shortIdInt = parseInt(realUserId, 10);
            const longIdInt = parseInt(tempId, 10);
            commit('SET_USER_ID', shortIdInt);
            // 存储长userId
            commit('SET_LONG_USER_ID', longIdInt);
            // 如果提供了用户名，也设置到 state 中
            if (userName) {
              commit('SET_USER_NAME', userName);
            }
            // 将获取到的 userId、长userId和用户名以 JSON 字符串形式存入 sessionStorage，包含联网搜索默认关闭配置
            const userIdPayload = JSON.stringify({ id: shortIdInt, longId: longIdInt, userName: userName, webSearchEnable: false });
            sessionStorage.setItem('userId', userIdPayload);
            try { localStorage.setItem('userId', userIdPayload); localStorage.setItem('_authCachedAt', Date.now().toString()); } catch (e) {}
            // console.log('用户ID、长ID和用户名已存入 sessionStorage 联网搜索默认关闭');
            // 获取用户token
            // try {
            //   const tokenResponse = await getUserToken(realUserId);
            //   if (tokenResponse.data && tokenResponse.data.token) {
            //     sessionStorage.setItem('usertoken', tokenResponse.data.token);
            //   }
            // } catch (error) {
            //   console.log('获取用户token失败:', error);
            // }
          } else {
            throw new Error('未能从服务器获取到有效的用户ID');
          }
        };

        if(loginInfoFromUrl) { // 先判断from oa.lawxp.com loginInfo
          // sessionStorage.setItem('userType', '200'); //oa model展示
          sessionStorage.setItem('fromOA', 'true');
          try { localStorage.setItem('fromOA', 'true'); } catch (e) {}
          const responselogin = await getLoginInfo(encodeURIComponent(loginInfoFromUrl)); // encrypted_param接口返回长userId，已进行encodeURIComponent编码
          const realLoginInfo = responselogin.data?.user_id;
          const userName = responselogin.data?.user_name; // 获取用户名
          //这里需要判断 realLoginInfo 的值，当是 realLoginInfo == "解密失败" 时，请跳转到 https://oa.lawxp.com/ 
          if (realLoginInfo) { // OA获得长userId
            // 当fromOA为true时，realLoginInfo作为长userId传入processUserId，会被存储为longId
            await processUserId(realLoginInfo, userName); //userId userName
          } else {
            throw new Error('loginInfo useId未获取');
          }
        } else if (tempIdFromUrl && token) { // 再判断userId
          // 检查是否是electron登录（LoginDialog已完成登录流程）
          const electronLoginCompleted = sessionStorage.getItem('electronLoginCompleted');
          if (electronLoginCompleted === 'true') {
            // electron登录已完成，URL中的userId已经是短userId，直接使用
            console.log('electron登录已完成，使用短userId:', tempIdFromUrl);
            commit('SET_USER_ID', tempIdFromUrl);
            sessionStorage.setItem('fromOA', 'false');
            sessionStorage.setItem('pctoken', token);
            try { localStorage.setItem('fromOA', 'false'); localStorage.setItem('pctoken', token); } catch (e) {}
          } else {
            // 普通PC登录流程
            let pcUserName = '';
            let longUserId = tempIdFromUrl; // 长userId
            if (token) {
              sessionStorage.setItem('fromOA', 'false'); //pc - token
              sessionStorage.setItem('pctoken', token);
              try { localStorage.setItem('fromOA', 'false'); localStorage.setItem('pctoken', token); } catch (e) {}
              try {
                // 调用saveToken接口存储token
                const saveTokenData = {
                  user_long_id: longUserId,
                  token: token
                };
                const saveTokenResponse = await saveToken(saveTokenData);
                // console.log('web存储 token 成功');
                // 存储token到sessionStorage
              } catch (error) {
                console.error('调用 saveToken 接口失败:', error);
              }
              // 有token时才尝试从PC获取用户信息
              try {
                const userInfoResponse = await getPCuserInfo(token, longUserId);
                if (userInfoResponse.data && userInfoResponse.data.user_name) {
                  longUserId = userInfoResponse.data.user_id;
                  pcUserName = userInfoResponse.data.user_name;
                  console.log('token获取PC用户名', pcUserName);
                  // if(userInfoResponse.data.type) { // 移除模型训练展示判断
                  //   let userType = userInfoResponse.data.type;
                  //   sessionStorage.setItem('userType', userType);
                  // }
                }
              } catch (error) {
                console.log('token获取PC用户名失败:', error);
              }
            }
            if(longUserId) { // 长userId 获取短userId
              // 使用辅助函数处理userId，并传入获取到的用户名
              await processUserId(longUserId, pcUserName);
            }
          }
        }else{
          const storedPctoken = sessionStorage.getItem('pctoken');
          const storedLoginInfo = sessionStorage.getItem('loginInfoFromUrl');
          const storedUserId = sessionStorage.getItem('userId');
          if (storedUserId && (storedPctoken || storedLoginInfo)) {
            // 必须同时有 userId 且存在 pctoken 或 loginInfoFromUrl 凭据才允许恢复（安全校验）
            try {
              const userData = JSON.parse(storedUserId);
              if (userData.id) {
                commit('SET_USER_ID', userData.id);
                if (userData.userName) {
                  commit('SET_USER_NAME', userData.userName);
                }
                if (userData.longId) {
                  commit('SET_LONG_USER_ID', userData.longId);
                }
                return;
              }
            } catch (e) {
              console.warn('解析 sessionStorage userId 失败:', e);
            }
          }
          sessionStorage.removeItem('userId');
          try { localStorage.removeItem('userId'); localStorage.removeItem('_authCachedAt'); } catch (e) {}
        }
      } catch (error) {
        console.log('用户身份初始化失败:', error);
      } finally {
        // 设置用户身份信息未获取的状态
        if(!state.userId) {
          if (isDesktop) {
            // 桌面端（Tauri / Electron）统一弹登录窗，不做路由跳转
            // commit('SET_SHOW_LOGIN_DIALOG', true); // 老invoke桌面端
            commit('SET_SHOW_LOGIN_WEB_DIALOG', true); // 以web弹窗登录
          } else {
            // console.log("当前环境:web");
            // Web 环境下显示登录对话框
            // commit('SET_SHOW_LOGIN_WEB_DIALOG', true); // test web login dialog
            // 先重置错误状态为null，确保值变化能触发watch
            if (state.initError === '用户身份信息未获取') {
              commit('SET_INIT_ERROR', null);
              // 使用微任务确保两次commit之间有响应式更新间隔，让watch能捕获到null→错误值的变化
              await Promise.resolve();
            }
            commit('SET_INIT_ERROR', '用户身份信息未获取');
          }
        }
        commit('SET_INITIALIZING', false);
      }
    }
  },
  modules: {
  }
})